// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyleProps as CheckboxStyleProps } from "@insite/mobius/Checkbox/Checkbox";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import ChevronUp from "@insite/mobius/Icons/ChevronUp";
import Minus from "@insite/mobius/Icons/Minus";
import Plus from "@insite/mobius/Icons/Plus";
import { productListFilterAccordionSectionStyles } from "@sc/Overrides/Widgets/ProductList/ProductListFilterAccordionSection";
import Search from "@sc/XDL/Icons/Search";
import { fontConfig } from "@sc/XDL/PreStyle/typography";
import { color, createLinkIconStyles, styledScrollbar } from "@sc/XDL/Utilities";
import { css } from "styled-components";

productListFilterAccordionSectionStyles.accordionSection = {
    mergeCss: true,
    expandIconProps: {
        src: ChevronDown,
        size: 13,
    },
    collapseIconProps: {
        src: ChevronUp,
        size: 13,
    },
    titleTypographyProps: {
        size: 12,
        lineHeight: "13px",
        weight: fontConfig.weight.bold,
    },
    headerProps: {
        css: css`
            border: none;
            border-top: 1px solid ${color("common.border")};
            height: 33px;
            &&& button,
            &&& button:focus {
                margin-bottom: 0;
                padding: 8px 7px 9px 12px;
                border: none;
            }
        `,
    },
    panelProps: {
        css: css`
            border: none;
            padding: 0 5px 9px 13px;
        `,
    },
};
productListFilterAccordionSectionStyles.checkBox = {
    css: css<CheckboxStyleProps>`
        width: 100%;
        span[role="checkbox"] {
            margin: 0;
        }
        &&& label {
            display: flex;
            justify-content: space-between;
            margin-left: 8px;
        }
    `,
    typographyProps: {
        lineHeight: "14px",
        css: css`
            word-break: break-all;
            width: 100%;
        `,
    },
};
productListFilterAccordionSectionStyles.checkBoxGroup = {
    css: css`
        width: 100%;
        flex-direction: row;
        &:not(:last-child) {
            margin-bottom: 4px;
        }
    `,
};

productListFilterAccordionSectionStyles.facetFilterTextField = {
    iconProps: {
        src: Search,
        color: "common.ui7",
        css: css`
            &&& {
                padding: 0;
                width: 23px;
            }
        `,
    },
    sizeVariant: "small",
    cssOverrides: {
        formField: css`
            width: 100%;
            margin-bottom: 12px;
        `,
    },
};
productListFilterAccordionSectionStyles.facetFilterTextFieldWrapper = {
    css: css`
        margin-right: 13px;
    `,
};

productListFilterAccordionSectionStyles.scrollableContainer = {
    css: css`
        position: relative;
        display: flex;
        flex-direction: column;
        max-height: 210px;
        overflow-x: hidden;
        padding: 2px 4px 2px 0;
        width: 100%;
        ${styledScrollbar(4, 0, 2)}
    `,
};

productListFilterAccordionSectionStyles.seeMoreLink = {
    ...createLinkIconStyles(Plus),
};

productListFilterAccordionSectionStyles.seeLessLink = {
    ...createLinkIconStyles(Minus),
};
